import React from 'react';
import ReactDOM from 'react-dom/client';
// import App from './App';
import Rout from './Route';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Rout />
  </React.StrictMode>
);

